// The file kinds Document Control files - the same list as
// back/utils/docTypes.js, so the picker offers exactly what the server takes.
export const DOC_KINDS = [
  { kind: "pdf", label: "PDF", ext: ["pdf"] },
  { kind: "image", label: "Image", ext: ["png", "jpg", "jpeg", "gif", "webp", "bmp", "tif", "tiff", "svg", "heic"] },
  { kind: "cad", label: "CAD drawing", ext: ["dwg", "dxf", "dwf", "dwfx", "dgn"] },
  { kind: "model", label: "Model", ext: ["rvt", "rfa", "rte", "ifc", "ifczip", "ifcxml", "nwd", "nwc", "nwf", "skp", "3dm", "fbx", "obj", "glb", "gltf"] },
  { kind: "spreadsheet", label: "Spreadsheet", ext: ["xlsx", "xls", "xlsm", "xlsb", "csv", "tsv", "ods"] },
  { kind: "schedule", label: "Project schedule", ext: ["xer", "mpp", "mpx", "xml", "pmxml", "p6xml", "pp"] },
  { kind: "document", label: "Document", ext: ["docx", "doc", "rtf", "txt", "odt", "md", "pptx", "ppt"] },
  { kind: "archive", label: "Archive", ext: ["zip", "7z", "rar"] },
  { kind: "email", label: "Email", ext: ["msg", "eml"] },
  { kind: "video", label: "Video", ext: ["mp4", "mov", "webm", "m4v"] },
];
const BY_EXT = new Map(DOC_KINDS.flatMap((k) => k.ext.map((e) => [e, k.kind])));
export const KIND_LABEL = Object.fromEntries(DOC_KINDS.map((k) => [k.kind, k.label]));
export const DOC_ACCEPT = DOC_KINDS.flatMap((k) => k.ext.map((e) => `.${e}`)).join(",");
export const MAX_DOC_MB = 1000;
export const extOf = (name) => { const m = String(name || "").toLowerCase().replace(/\.gz$/, "").match(/\.([a-z0-9]{1,8})(\?|$)/); return m ? m[1] : ""; };
export const docKindOf = (name) => BY_EXT.get(extOf(name)) || null;
// A browser can preview it: a PDF (also gzipped from the Revit plugin) or a drawable image.
export const canPreview = (link) => /\.pdf(\.gz)?(\?|$)/i.test(String(link || "")) || /\.(png|jpe?g|gif|webp|bmp)(\?|$)/i.test(String(link || ""));
